import React from 'react'
import { Container, Col } from 'reactstrap'
import {
  Section,
  Blockquote,
  Cite,
  RowCentered,
  TextContainer
} from '../../GlobalStyles'
import theme from '../../theme'

export const Testimonials = () => {
  return (
    <Section bgColor={theme.colors.darkGray}>
      <Container>
        <RowCentered>
          <TextContainer as={Col} xs='12' md='6'>
            <Blockquote color={theme.colors.lightenGray}>
              "I would tell other CMAA Members to definitely have their PGA
              Professionals go out and get the training for this program and
              implement it at their club. It really has resulted in a great
              experience for our juniors here."
            </Blockquote>
            <Cite color={theme.colors.lightenGray} marginBottom='0'>
              - Kimberly Perez, COO/CFO, Golf Club of Avon
            </Cite>
          </TextContainer>
        </RowCentered>
      </Container>
    </Section>
  )
}

export default Testimonials
